import React, { useEffect, useState } from "react";
import "./OverallLeaderboard.css";
import useUserInfo from "../../../../Hooks/useUserInfo";
import Tv from "../../Tv";
import {
  SquadListApi,
  SquadDetails,
  getDailyBattleRuns,
  getFavTeamRuns,
  getOverAllPoints,
  IplTeamList,
  fetchOverallTeamPoints,
  topOverAllLeagueLeaderboard,
  topClgLeagueLeaderboard,
} from "../../../../apis/iplBattle";
import BattleLeaderBoard from "../LeaderBoard";
import MatchScheduleList from "../matchsceduleList";

const OverallLeaderboard = () => {
    const { updateUserInfo, userDetails,watchScreen } = useUserInfo();

    // Add state for squads and squad details
    const [squadTeam, setSquadTeam] = useState([]);
    const [selectedSquad, setSelectedSquad] = useState(null);
    const [squadDetail, setSquadDetail] = useState([]);
    const [loading, setLoading] = useState(false);
    const [IplTeam, setIplTeam] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState(IplTeam?.[0]?._id);
    const [selectedSquadCode, setSelectedSquadCode] = useState(null);

    // Add new state for leaderboard data
    const [dailyRuns, setDailyRuns] = useState([]);
    const [yourDailyRuns, setYourDailyRuns] = useState([]);
    const [FavTeam, setFavTeam] = useState([]);
    const [yourFavTeam, setYourFavTeam] = useState([]);
    console.log(yourFavTeam,'yourFavTeam')
    const [overAllRuns, setOverAllRuns] = useState([]);
    const [OverAllRunsIndividual, setOverAllRunsIndividual] = useState([]);
    const [squadId, setSquadId] = useState(null);
    const [teamPoints, setTeamPoints] = useState([]);
    // Add state for Squad Leaderboard
    const [squadLeaderboard, setSquadLeaderboard] = useState([]);
    const [yourSquadLeaderboardRank, setYourSquadLeaderboardRank] = useState(null);
    const [collegeLeaderboard, setCollegeLeaderboard] = useState([]);
    const [yourCollegeLeaderboardRank, setYourCollegeLeaderboardRank] = useState(null);

    const IsTBD = process.env.REACT_APP_IS_TBD_ID;

    // Fetch squad list
    const fetchSquadList = async () => {
        setLoading(true);
        try {
            const response = await SquadListApi(userDetails?.userDetails?.telegramId);
            console.log("SquadListApi response:", response);
            if (response && response.userSquads && response.userSquads.length > 0) {
                setSquadTeam(response.userSquads);
                setSelectedSquad(response.userSquads[0]?.squadId);
                // Optionally fetch squad details for the first squad
                fetchPrivateLeagueList(response.userSquads[0]?.squadId);
            }
        } finally {
            setLoading(false);
        }
    };

    // Fetch squad details (private league) - Fix this function definition
    const fetchPrivateLeagueList = async (selectedSquadId) => {
        if (!selectedSquadId) return;
        
        setLoading(true);
        try {
            const response = await SquadDetails(selectedSquadId);
            console.log("SquadDetails response:", response);
            if (response && Array.isArray(response)) {
                const sortedResponse = [...response?.usersData]?.sort((a, b) => a.rank - b.rank);
                setSquadDetail(sortedResponse);
            } else {
                setSquadDetail(response?.usersData);
            }
        } finally {
            setLoading(false);
        }
    };

    // Remove the incorrect conditional block
    // if(squadId){
    //   const fetchPrivateLeagueList = async (selectedSquadId) => {
    //     ...
    //   };
    //   fetchPrivateLeagueList
    // }

    // Add new API functions
    const OverAllBattleRuns = async () => {
        setLoading(true);
        try {
            const response = await getDailyBattleRuns(
                watchScreen?.current_battle?._id,
                watchScreen?.cricketLeague
            );
            console.log("getDailyBattleRuns response:", response);
            setDailyRuns(response?.topUsers);
            setYourDailyRuns(response?.yourDetails);
        } finally {
            setLoading(false);
        }
    };

    

    const getFavTeam = async () => {
        setLoading(true);
        try {
            const response = await getFavTeamRuns(
                selectedTeam,watchScreen?.cricketLeague );
            console.log("getFavTeamRuns response:", response);
            setFavTeam(response?.topUsers);
            setYourFavTeam(response?.yourDetails);
        } finally {
            setLoading(false);
        }
    };

    const OverAllRuns = async () => {
        setLoading(true);
        try {
            const response = await getOverAllPoints(
                watchScreen?.cricketLeague
            );
            console.log("getOverAllPoints response:", response);
            setOverAllRuns(response?.topUsers);
            setOverAllRunsIndividual(response?.yourDetails);
        } finally {
            setLoading(false);
        }
    };

    const getTeamPoints = async () => {
      setLoading(true);
      try {
          const response = await fetchOverallTeamPoints(watchScreen?.cricketLeague);
          console.log("Team Points response:", response);
          if (response && response.teams) {
              setTeamPoints(response.teams);
          }
      } finally {
          setLoading(false);
      }
  };

    // Add Squad Leaderboard fetch function
    const fetchSquadLeaderboard = async () => {
        setLoading(true);
        try {
            const response = await topOverAllLeagueLeaderboard();
            console.log("Squad Leaderboard response:", response);
            if (response) {
                // Update to use the correct response structure
                setSquadLeaderboard(response?.topOverAllLeague || []);
                setYourSquadLeaderboardRank(response?.yourOverAllLeague?.[0] || null);
            }
        } finally {
            setLoading(false);
        }
    };

    // Add College Leaderboard fetch function
    const fetchCollegeLeaderboard = async () => {
        setLoading(true);
        try {
            const response = await topClgLeagueLeaderboard();
            console.log("College Leaderboard response:", response);
            if (response) {
                setCollegeLeaderboard(response?.topClgLeague || []);
                setYourCollegeLeaderboardRank(response?.yourClgLeague?.[0] || null);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // fetchSquadList();
        // OverAllBattleRuns();
        OverAllRuns();
        fetchSquadLeaderboard();
        fetchCollegeLeaderboard(); // Add this call to fetch college leaderboard
        // PrivateLeagueList();
    }, []);


    useEffect(() => {
        const fetchTeamAndSquad = async () => {
            updateUserInfo((prev) => ({
                ...prev,
                isLoading: true,
            }));
            const result = await IplTeamList(watchScreen?.cricketLeague);
            const Squad = await SquadListApi(userDetails?.userDetails?.telegramId);
            console.log("Squad List Response:", Squad);
        
            if (Squad && Squad.userSquads && Squad.userSquads.length > 0) {
                setSquadTeam(Squad.userSquads);
                setSelectedSquad(Squad.userSquads[0]?.squadId);
                setSelectedSquadCode(Squad?.userSquads[0]?.squadCode);
                fetchPrivateLeagueList(Squad.userSquads[0]?.squadId);
                setSquadId(Squad.userSquads[0]?.squadId);
            }
        
            if (result) {
                setIplTeam(result?.teams?.filter((el)=>el?._id!=IsTBD));
                setSelectedTeam(result?.teams?.[0]?._id);
                console.log(selectedTeam,'selectedTeam')
                getTeamPoints(); // Add this line to fetch team points
            } else {
                console.log("error in api match");
            }
        
            updateUserInfo((prev) => ({
                ...prev,
                isLoading: false,
            }));
        };
    
        fetchTeamAndSquad();
    }, []);

  
    useEffect(() => {
        if (selectedTeam) {
            getFavTeam();
        }
    }, [selectedTeam]);

    const goToThePage = (component, name, leaderboardType) => {
      updateUserInfo((prev) => ({
        ...prev,
        currentComponent: component,
        currentComponentText: name,
        lastComponent: userDetails.currentComponent,
        lastComponentText: userDetails.currentComponentText,
        centerCount: userDetails.centerCount + 1,
        selectedLeaderboardType: leaderboardType // Add this to track which leaderboard to show
      }));
    };      
      const goToBackPage  = (component, name, leaderboardType) => {
        updateUserInfo((prev) => ({
          ...prev,
          currentComponent:userDetails?.lastComponentText=="BattleLeaderBoard"?MatchScheduleList: userDetails?.lastComponent,
          currentComponentText: userDetails?.lastComponentText=="BattleLeaderBoard"?"MatchScheduleList":userDetails?.lastComponentText,
          lastComponent: userDetails.currentComponent,
          lastComponentText: userDetails.currentComponentText,
          centerCount: userDetails.centerCount + 1,
          selectedLeaderboardType: leaderboardType // Add this to track which leaderboard to show
        }));
      };
  return (
    <>
    <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg" class="cancel-imgleaderboard" onClick={()=>goToBackPage(MatchScheduleList,'MatchScheduleList')} style={{pointerEvents:"fill"}}></img>
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <h2 className="leaderboard-text" style={{ marginTop:"0px" }}>
          LEADERBOARD
        </h2>
        <div className="overall-leaderboard-root">
          {/* Overall Runs Section */}
          <div className="olb-card" onClick={() => goToThePage(BattleLeaderBoard, 'BattleLeaderBoard', 'OVERALL RUNS')}>
            <div className="olb-card-header">
              <span>OVERALL RUNS</span>
              <span className="olb-arrow">{">"}</span>
            </div>
            <div className="olb-card-bar">
              <span className="olb-user-ellipsis">
                {OverAllRunsIndividual?.username || "YOU"}
              </span>
              <span className="olb-rank">
                #{OverAllRunsIndividual?.rank || "-"}
              </span>
            </div>
          </div>
          
          {/* Teams Points Table Section */}
          {teamPoints && teamPoints.length > 0 && (
            <div className="olb-card" onClick={() => goToThePage(BattleLeaderBoard, 'BattleLeaderBoard', 'TEAMS POINTS TABLE')}>
              <div className="olb-card-header">
                <span>TEAMS POINTS TABLE</span>
                <span className="olb-arrow">{">"}</span>
              </div>
              <div className="olb-card-bar">
                <span className="olb-user-ellipsis">
                  {(() => {
                    // Find user's favorite team in teamPoints based on favTeamName
                    if (OverAllRunsIndividual?.favTeamName) {
                      const userFavTeam = teamPoints.find(
                        team => team.teamName?.toUpperCase() === OverAllRunsIndividual.favTeamName?.toUpperCase()
                      );
                      if (userFavTeam) {
                        return userFavTeam.teamName || "TEAM";
                      }
                    }
                    // Fallback to first team if no match found
                    return teamPoints[0]?.teamName || "TEAM";
                  })()}
                </span>
                <span className="olb-rank">
                  {(() => {
                    // Find user's favorite team rank based on favTeamName
                    if (OverAllRunsIndividual?.favTeamName) {
                      const userFavTeam = teamPoints.find(
                        team => team.teamName?.toUpperCase() === OverAllRunsIndividual.favTeamName?.toUpperCase()
                      );
                      if (userFavTeam) {
                        return "#" + (userFavTeam.rank || "1");
                      }
                    }
                    // Fallback to first team rank if no match found
                    return "#" + (teamPoints[0]?.rank || "1");
                  })()}
                </span>
              </div>
            </div>
          )}
          
          {/* Favorite Team Section */}
          {yourFavTeam && (
            <div className="olb-card" onClick={() => goToThePage(BattleLeaderBoard, 'BattleLeaderBoard', 'MOST FAVOURITE RUNS')}>
              <div className="olb-card-header">
                <span>MOST FAVOURITE RUNS</span>
                <span className="olb-arrow">{">"}</span>
              </div>
              <div className="olb-card-bar">
                <span className="olb-user-ellipsis">
                  {yourFavTeam?.username || "YOU"}
                </span>
                <span className="olb-rank">
                  #{yourFavTeam?.rank || "-"}
                </span>
              </div>
            </div>
          )}
          
          {/* Squad Leaderboard Section */}
          
          {/* {yourSquadLeaderboardRank && (
            <div className="olb-card" onClick={() => goToThePage(BattleLeaderBoard, 'BattleLeaderBoard', 'SQUAD LEADER BOARD')}>
              <div className="olb-card-header">
                <span>SQUAD LEADER BOARD</span>
                <span className="olb-arrow">{">"}</span>
              </div>
              <div className="olb-card-bar">
                <span className="olb-user-ellipsis">
                  {yourSquadLeaderboardRank?.squadName || "YOUR SQUAD"}
                </span>
                <span className="olb-rank">
                  #{yourSquadLeaderboardRank?.rank || "-"}
                </span>
              </div>
            </div>
          )} */}
          
          {/* Divider with centered text */}
          <div className="olb-hr-with-text">
            <span
              style={{
                background: "linear-gradient(90deg, #00ff85, #ff5ec4)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: "bold"
              }}
            >
              PRIVATE LEAGUE
            </span>
          </div>
          
          {/* Render squadTeam list below PRIVATE LEAGUE */}
          {squadTeam && squadTeam.length > 0 ? (
            squadTeam.map((squad, idx) => (
              <div className="olb-card" key={squad?.squadId || idx}>
                <div className="olb-card-header">
                  <span>{squad?.squadName.toUpperCase() || squad?.squadCode || `Squad ${idx + 1}`}</span>
                  <span className="olb-arrow">{">"}</span>
                </div>
                <div className="olb-card-bar">
                  <span className="olb-user-ellipsis">
                    {"YOU"}
                  </span>
                  <span className="olb-rank">
                    {"#"}{squad?.userRank || "#"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div style={{ color: "#aaa", fontSize: "14px", marginTop: "8px" }}>
              No squads found.
            </div>
          )}
          
          {/* Divider with centered text for Squad Leaderboard */}
          <div className="olb-hr-with-text">
            <span
              style={{
                background: "linear-gradient(90deg, #00ff85, #ff5ec4)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: "bold"
              }}
            >
              SQUAD LEADERBOARD
            </span>
          </div>
          
          {/* Render squadLeaderboard list */}
          {squadLeaderboard && squadLeaderboard.length > 0 ? (
            squadLeaderboard.map((squad, idx) => (
              <div className="olb-card" key={idx} onClick={() => goToThePage(BattleLeaderBoard, 'BattleLeaderBoard', 'SQUAD LEADER BOARD')}>
                <div className="olb-card-header">
                  <span>{squad?.squadName.toUpperCase() || `Squad ${idx + 1}`}</span>
                  <span className="olb-arrow">{">"}</span>
                </div>
                <div className="olb-card-bar">
                  <span className="olb-user-ellipsis">
                    {"RUNS:"}{squad?.squadRuns}
                  </span>
                  <span className="olb-rank">
                    {"#"}{squad?.rank || "#"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div style={{ color: "#aaa", fontSize: "14px", marginTop: "8px" }}>
              No squad leaderboard data found.
            </div>
          )}
          
          {/* Add College Leaderboard section before the closing div */}
          <div className="olb-hr-with-text">
            <span
              style={{
                background: "linear-gradient(90deg, #00ff85, #ff5ec4)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: "bold"
              }}
            >
              COLLEGE LEADERBOARD
            </span>
          </div>
          
          {/* Render collegeLeaderboard list */}
          {collegeLeaderboard && collegeLeaderboard.length > 0 ? (
            collegeLeaderboard.map((college, idx) => (
              <div className="olb-card" key={idx} onClick={() => goToThePage(BattleLeaderBoard, 'BattleLeaderBoard', 'COLLEGE LEADER BOARD')}>
                <div className="olb-card-header">
                  <span className="olb-user-ellipsis">{college?.squadName?.toUpperCase() || `College ${idx + 1}`}</span>
                  <span className="olb-arrow">{">"}</span>
                </div>
                <div className="olb-card-bar">
                  <span className="olb-user-ellipsis">
                    {"RUNS:"}{college?.squadRuns || 0}
                  </span>
                  <span className="olb-rank">
                    {"#"}{college?.rank || "#"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div style={{ color: "#aaa", fontSize: "14px", marginTop: "8px" }}>
              No college leaderboard data found.
            </div>
          )}
        </div>
      </div>
    </>
  );
};



export default OverallLeaderboard;

